module.exports = __webpack_public_path__ + "img/white_paper19.14f51a79.png";